<template>
  <v-app>
    <Notifications />
    <v-navigation-drawer
      v-if="isLoggedIn"
      v-model="drawer"
      fixed
      app
      class="no-print"
    >
      <v-list
        subheader
        class="py-1"
      >
        <v-list-item>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  class="hover-icon"
                  @click="handleLogout"
                  v-on="on"
                >
                  exit_to_app
                </v-icon>
              </template>
              <span>Вихід</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="title-list">
              {{ user ? user.title : "" }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ user ? roleName : "" }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <MainMenu :items="menuItems" />
      <v-divider />
      <MainMenuGenDoc :items="menuItemsGenDoc" />
      <v-divider />
      <MainMenuProjects :items="menuItemsProjects" />
      <MainMenuCrm :items="menuItemsCrm" />
      <MainMenuSales :items="menuItemsSales" />
      <MainMenuJsonDealer />
      <div
        v-if="roleName === 'Клієнт'"
        class="socials d-flex flex-column justify-center align-center"
      >
        <span class="body-1">
          Підпишись на нас:
        </span>
        <div class="d-flex align-center">
          <a
            href="https://www.youtube.com/channel/UCZtboz-uX8YFBWRwkwwTVLQ"
            target="_blank"
            class="socials__links-item"
          >
            <v-icon
              right
              dark
              large
              color="red"
            >
              mdi-youtube
            </v-icon>
          </a>
          <a
            href="https://t.me/tqmsystems"
            target="_blank"
            class="socials__links-item d-flex align-center"
          >
            <img
              src="../public/telegram.svg"
              width="28"
              height="28"
            >
          </a>
        </div>
      </div>
    </v-navigation-drawer>

    <v-app-bar
      v-if="isLoggedIn"
      dark
      height="45"
      app
      color="grey lighten-3"
      class="header grey--text text--darken-2 no-print"
    >
      <v-app-bar-nav-icon
        class="ml-1"
        style="width: 36px; height: 36px; color: #616161"
        @click="drawer = !drawer"
      />
      <v-toolbar-title>Кабінет</v-toolbar-title>
    </v-app-bar>

    <v-content class="grey lighten-2">
      <v-container fluid>
        <router-view :key="$route.fullPath" />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import auth from "./auth.js";
import MainMenu from "./components/MainMenu.vue";
import MainMenuGenDoc from "./GenDoc/components/MainMenuGenDoc.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import MainMenuProjects from "./projects/components/MainMenuProjects.vue";
import MainMenuCrm from "./Crm/components/MainMenuCrm.vue";
import MainMenuSales from "./sales/components/MainMenuSales.vue";
import MainMenuJsonDealer from "./json-dealer-module/components/MainMenuJsonDealer.vue";

export default {
  name: "App",
  components: {
    MainMenu,
    Notifications: () => import("./components/Notifications"),
    MainMenuGenDoc,
    MainMenuProjects,
    MainMenuCrm,
    MainMenuSales,
    MainMenuJsonDealer
  },
  data: () => ({
    drawer: true,
  }),
  computed: {
    ...mapGetters("user", [
      "menuItems",
      "isLoggedIn",
      "roleName",
      "menuItemsGenDoc",
      "menuItemsProjects",
      "menuItemsCrm",
      "menuItemsSales",
    ]),
    ...mapState("user", ["user"]),
  },
  created() {
    if (auth.loggedIn()) {
      this.login();
    }
  },
  methods: {
    ...mapActions("user", ["setUser", "logout", "login"]),
    handleLogout() {
      this.logout();
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="scss">
.header.v-toolbar {
  background-image: url("/header-bg.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
}
.theme--light.v-footer {
  max-height: 30px;
  background-image: url("/footer-bg.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
}
.primary-button {
  background-color: #f44336 !important;
  color: #fff !important;
}
.primary-button:hover {
  background-color: #388e3c !important;
}
.title-list {
  white-space: normal;
  overflow: visible;
}
.table-style {
  font-family: arial, sans-serif;
  border-spacing: 0;
  border-collapse: collapse;
}
.row-colomn-style {
  border: 1px solid #dddddd;
  text-align: right;
  padding: 5px;
  max-width: 100%;
}
.print__container {
  background: #fff;
  min-width: 100%;
}
.v-pagination__item,
.v-pagination__navigation {
  outline: 0;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #d4d4d4;
}

::-webkit-scrollbar-thumb {
  background: #939393;
  border-radius: 8px;
  border: 3px solid #d4d4d4;
}
.cursor-pointer {
  cursor: pointer;
}
@media print {
  .no-print {
    display: none;
  }
  .footer-space.print,
  .header-space.print,
  .pageHeader.print,
  .pageFooter.print {
    display: block;
  }
  @page {
    margin: 0.5cm;
  }
  .footer-space.print,
  .header-space.print,
  .pageHeader.print,
  .pageFooter.print {
    display: block;
  }
  main {
    padding-left: 0 !important;
    padding-top: 0 !important;
  }
  tr,
  li,
  p {
    page-break-inside: avoid;
  }
  .gen-doc-table table th,
  .gen-doc-table table td {
    word-wrap: break-word;
  }
  .gen-doc-table table {
    margin: 24px 0;
  }
}
.theme--light.v-label {
  color: #b9b9b9;
}

.socials {
  &__links-item {
    color: #fff !important;
  }
}

/* for stop rotation of autocomplete icon */
.notranslate {
  transform: none !important;
}

/* for handle select in modal window */

.v-tab {
  pointer-events: auto !important;
}
.hover-block {
  transition: opacity 0.4s ease-in-out;
}

.hover-block:hover {
  opacity: 0.8;
  color: #e57373 !important;
}

.show-btn-on-hover {
  color: #e57373 !important;
}
.invisible-block {
  display: none;
}
@media print {
  .no-print {
    display: none !important;
  }
  .print {
    display: block !important;
  }
  tr,
  li,
  p {
    page-break-inside: avoid;
  }
}
</style>
